export class LogAdapter {
    constructor() {
    }
    log = () => {
    };
    info = () => {
    };
    warn = () => {
    };
    error = () => {
    };
    table = () => {
    };
    group = () => {
    };
    groupCollapsed = () => {
    };
    groupEnd = () => {
    };
}
